export default [
    {
        path: "/cms",
        name: "cms__root__",
        redirect: {
            name: "cms-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "cms",
            title: "",
        },
        children: [
            {
                path: "index",
                name: "cms-index",
                component: () => import("@/views/cms/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/cms/promotion",
        name: "cms-promotion",
        meta: {
            title: "推广中心",
            icon: "promotion",
            parent: "cms",
            permission: "manage_common_banner",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/promotion/banner",
        children: [
            {
                path: "banner",
                name: "cms-promotion-banner",
                component: () => import("@/views/cms/promotion/banner.vue"),
                meta: {
                    title: "图文推广",
                    icon: "banner",
                },
            },
        ],
    },
    {
        path: "/cms/document",
        name: "cms-document",
        meta: {
            title: "文档中心",
            icon: "document-mng",
            parent: "cms",
            permission: "manage_common_document",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/document/common",
        children: [
            {
                path: "common",
                name: "cms-document-common",
                component: () => import("@/views/cms/document/index.vue"),
                meta: {
                    title: "通用文档",
                    icon: "document",
                },
            },
            {
                path: "detail/:id(\\d+)?",
                name: "cms-document-detail",
                hidden: true,
                component: () => import("@/views/cms/document/document-form.vue"),
                meta: {
                    title: "文档内容",
                    icon: "document",
                    affix: false,
                    activeMenu: "/cms/document/common",
                },
            },
        ],
    },
    {
        path: "/cms/ai",
        name: "cms-ai",
        meta: {
            title: "智能回复",
            icon: "ai",
            parent: "cms",
            permission: "manage_ai",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/ai/keyword",
        children: [
            {
                path: "keyword",
                name: "cms-ai-keyword",
                component: () => import("@/views/cms/ai/keyword.vue"),
                meta: {
                    title: "关键词",
                    icon: "intelligence-keywords",
                    permission: "manage_ai_keyword",
                },
            },
            {
                path: "keyword-detail/:id",
                name: "keyword-detail",
                component: () => import("@/views/cms/ai/keyword-detail.vue"),
                hidden: true,
                meta: {
                    title: "策略详情",
                    activeMenu: "/cms/ai/keyword",
                    permission: "manage_ai_keyword",
                },
            },
            {
                path: "keyword-edit/:id?",
                name: "keyword-edit",
                component: () => import("@/views/cms/ai/keyword-edit.vue"),
                hidden: true,
                meta: {
                    title: "策略详情",
                    activeMenu: "/cms/ai/keyword",
                    permission: "manage_ai_keyword",
                },
            },
            {
                path: "vocabulary",
                name: "intelligence-vocabulary",
                component: () => import("@/views/cms/ai/vocabulary.vue"),
                meta: {
                    title: "语音词",
                    icon: "intelligence-vocabulary",
                    permission: "manage_ai_pronunciation",
                },
            },
            {
                path: "vocabulary-detail/:id",
                name: "intelligence-vocabulary-detail",
                component: () => import("@/views/cms/ai/vocabulary-detail.vue"),
                hidden: true,
                meta: {
                    title: "语音热词详情",
                    activeMenu: "/cms/ai/vocabulary",
                    permission: "manage_ai_pronunciation",
                },
            },
            {
                path: "rag",
                name: "intelligence-rag",
                component: () => import("@/views/cms/ai/rag.vue"),
                meta: {
                    title: "知识库",
                    icon: "intelligence-rag",
                    permission: "manage_ai_rag",
                },
            },
            {
                path: "rag-detail/:id",
                name: "intelligence-rag-detail",
                component: () => import("@/views/cms/ai/rag-detail.vue"),
                hidden: true,
                meta: {
                    title: "知识库详情",
                    activeMenu: "/cms/ai/rag",
                    permission: "manage_ai_rag",
                },
            },
            {
                path: "chat",
                name: "intelligence-chat",
                component: () => import("@/views/cms/ai/chat.vue"),
                meta: {
                    title: "语料库",
                    icon: "intelligence-chat",
                    permission: "manage_ai_chat",
                },
            },
            {
                path: "chat-edit/:id?",
                name: "intelligence-chat-edit",
                component: () => import("@/views/cms/ai/chat-edit.vue"),
                hidden: true,
                meta: {
                    title: "语料详情",
                    activeMenu: "/cms/ai/chat",
                    permission: "manage_ai_chat",
                },
            },
            {
                path: "history",
                name: "intelligence-history",
                component: () => import("@/views/cms/ai/history.vue"),
                meta: {
                    title: "历史会话",
                    icon: "intelligence-history",
                    permission: "manage_ai_history",
                },
            },
            {
                path: "history-detail/:id",
                name: "intelligence-history-detail",
                component: () => import("@/views/cms/ai/history-detail.vue"),
                hidden: true,
                meta: {
                    title: "会话详情",
                    activeMenu: "/cms/ai/history",
                    permission: "manage_ai_history",
                },
            },
            {
                path: "overview",
                name: "intelligence-overview",
                component: () => import("@/views/cms/ai/overview.vue"),
                meta: {
                    title: "统计分析",
                    icon: "intelligence-stat",
                    permission: "manage_ai_stat",
                },
            },
        ],
    },
    {
        path: "/cms/oss",
        name: "cms-oss",
        meta: {
            title: "资源管理",
            icon: "config-file",
            parent: "cms",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/oss/file",
        children: [
            {
                path: "file",
                name: "cms-oss-file",
                component: () => import("@/views/cms/oss/file-mng.vue"),
                meta: {
                    title: "文件管理",
                    icon: "oss",
                    permission: "manage_upload_file",
                    group: 512,
                },
            },
            {
                path: "log",
                name: "cms-oss-log",
                component: () => import("@/views/cms/oss/log.vue"),
                meta: {
                    title: "上传日志",
                    icon: "upload-log",
                    permission: "manage_upload_log",
                },
            },
        ],
    },
];
